import { render, staticRenderFns } from "./SeccionDiciplinaPage.vue?vue&type=template&id=3d3d22de"
import script from "./SeccionDiciplinaPage.js?vue&type=script&lang=js&external"
export * from "./SeccionDiciplinaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports